<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
            <b-card no-body class="p-4">
              <b-card-body>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                <form @submit="submit">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <input required="true" type="text" class="form-control" placeholder="Username" v-model="credentials.username">
                  </b-input-group>
                  <b-input-group class="mb-2">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <input required="true" type="password" class="form-control" placeholder="Password" v-model="credentials.password">
                  </b-input-group>
                  <b-row @if="error != ''" class="mb-4">
                    <b-col cols="6">
                      <h6 class="text-red">{{ error }}</h6>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="6">
                      <b-button type="submit" variant="primary" class="px-4" >Login</b-button>
                    </b-col>
                    <!--
                      <b-col cols="6" class="text-right">
                        <b-button variant="link" class="px-0">Forgot password?</b-button>
                      </b-col>
                    -->
                  </b-row>
                </form>
              </b-card-body>
            </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { login } from '@/services/auth'
import { login as loginEx } from '@/services/external/auth'

export default {
  name: 'Login',
  data () {
    return {
      credentials: {
        username: '',
        password: ''
      },
      error: ''
    }
  },
  methods: {
    submit () {
      loginEx()
        .then(response => {
          login(this.credentials)
            .then(response => {
              this.$router.push('/')
            })
            .catch((exception) => {
              console.log(exception)
            })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Login.vue